module.exports = __webpack_public_path__ + "img/weal_content_1.e008ef94.png";